<template>
  <div class="talbe_content">
    <el-table
    :data="items"
    border
    style="width: 100%" v-loading="listLoading" @select="handleSelectionChange" @select-all="handleSelectionChangeAll">
    <el-table-column
      type="index"
      label="序号"
      width="50"
      align="center">
    </el-table-column>
    <el-table-column
      type="selection"
      width="55" v-if="selectShow" >
    </el-table-column>
    <template v-for="(header, index) in headers" >
      <el-table-column
      v-if="header.show !== false && header.show === 'template'"
      :key="index"
      :prop="header.prop"
      :label="header.label"
      :width="header.width || 'auto'"
      align="center"
      >
        <template slot-scope="scope">
          <slot :name="header.prop" :props="scope"></slot>
        </template>
    </el-table-column>

    <el-table-column
      v-if="header.show !== false && header.show !== 'template'"
      :key="index"
      :prop="header.prop"
      :label="header.label"
      :width="header.width || 'auto'"
      align="center"
      >
    </el-table-column>
    </template>

    <el-table-column v-if="oprateOption.hasOprate"
      :label="oprateOption.oprateName"
      :width="oprateOption.width"
      align="center"
    >
      <template slot-scope="scope">
        <el-button  v-for="(oprateItem, index2) in oprateItems"
        :key="index2"
        @click="handleClick(scope.row, oprateItem.method)"
        :type="oprateItem.type || 'text'"
        size="small"
        :class="{'hideBtn': (scope.row.btnStatus && scope.row.btnStatus[oprateItem.key] || 'show')==='hide'}"
        >{{oprateItem.text}}</el-button>
      </template>
    </el-table-column>
  </el-table>
  <div class="page_nation_content" v-if="showPageNation">
    <el-pagination
      background
      layout=" prev, pager, next,total"
      @current-change="pageChangeFn"
      :page-size="pageSize"
      :current-page="curPage"
      :total="totalNum">
    </el-pagination>
    
  </div>

  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  },
  props: {
    // 表格高度
    tableHeight: {
      type: String,
      default: 'auto'
    },
    //表格的loading
    listLoading:{
      type: Boolean,
      default: true,
    },
    //是否显示选框
    selectShow:{
      type: Boolean,
      default: false,
    },
    // 是否显示分页
    showPageNation: {
      type: Boolean,
      default: true,
    },
    // 操作表头 行参数
    oprateOption: {
      type: Object,
      default: function () {
        return {
          hasOprate: true, // 是否显示操作行
          oprateName: '操作',
          width: 'auto'
        }
      }
    },
    // 表头数据
    headers: {
      type: Array,
      default: function () {
        return []
      }
    },
    // 表内容数据
    items: {
      type: Array,
      default: function () {
        return []
      }
    },
    // 操作按钮
    oprateItems: {
      type: Array,
      default: function () {
        return []
      }
    },
    curPage: {
      type: Number,
      default: 1
    },
    // 每页多少条数据
    pageSize: {
      type: Number,
      default: 10
    },
    // 数据总条数
    totalNum: {
      type: Number,
      default: 0,
    },
    //总页数
    pagerCount: {
      type: Number,
      default: 1,
    }
  },
  methods: {
    handleClick(row, method) {
        //console.log(row);
        this.$emit(method, row)
    },
    pageChangeFn(p) {
      this.$emit('getTableData', p);
    },
    handleSelectionChange(val){
      // debugger
      this.$emit('selecChange', val);
    },
    handleSelectionChangeAll(valAll){
      this.$emit('selecChange', valAll);
    }
  }
}
</script>
<style lang="scss" scoped>
.page_nation_content {
  padding-top: 20px;
}
.showBtn{
  display:block!important;
}
.hideBtn{
  display:none;
}
</style>



// WEBPACK FOOTER //
// index.vue?03d92f08